<template>
  <div class="mision">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid"
      />
    </router-link>

    <section class="pantalla mision1_3">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div
              @click="retroceder"
              class="btnretroceder abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../assets/imgs/mision/bg-flecha-atras.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Regresar a </span>
                <span class="bold">vías y match</span>
              </div>
            </div>

            <a
              @click="generaPDF()"
              class="btn-descarga"
              data-aos="fade-up"
              data-aos-delay="400"
              v-if="perfil_stem == false"
            >
              <img
                src="../../assets/imgs/resultados/btn-resultado-final.png"
                alt="Encauce"
                class="img-fluid"
              />
            </a>

            <div
              class="btn-descarga text-center dialogo"
              v-if="perfil_stem == true"
            >
              <p class="blanco bold fpG">
                Cuentas con perfil<span class="amarillo fpG2"> STEM </span> con
                aptitud para
                <span class="amarillo fpG2"
                  >Ciencias, Tecnología, Ingeniería y Matemáticas</span
                >.
              </p>
              <p class="fpG">
                <span class="blanco bold"
                  >¿Quieres conocer más sobre las
                  <span class="amarillo fpG2">carreras STEM</span>?</span
                >
              </p>
              <p class="blanco bold fpG">
                Entra a
                <a
                  class="amarillo fpG2"
                  href="https://www.movimientostem.org/"
                  target="_blank"
                  >https://www.movimientostem.org/</a
                >
              </p>

              <div class="col-8 offset-2">
                <a
                  @click="generaPDF()"
                  class="pt4"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <img
                    src="../../assets/imgs/resultados/btn-resultado-final.png"
                    alt="Encauce"
                    class="img-fluid"
                  />
                </a>
              </div>
            </div>

            <!-- <a target="_blank" download href="https://firebasestorage.googleapis.com/v0/b/encauce.appspot.com/o/Resultados.pdf?alt=media&token=8b6f2537-4ff2-4039-8ba5-c1863fb55ced" class="btn-descarga" data-aos="fade-up" data-aos-delay="400">
              <img
                src="../../assets/imgs/resultados/btn-resultado-final.png"
                alt="Encauce"
                class="img-fluid"
              />
            </a> -->
            <!-- 
            <div class="btn-descarga text-center" data-aos="fade-up" data-aos-delay="400">
              <div class="electrico bold fpXXG">¡Gracias por responder!</div>
            </div> -->

            <div
              class="personaje abs"
              data-aos="fade"
              data-aos-delay="800"
              v-if="settings.personaje != null && avance != null"
            >
              <img
                :src="
                  require('../../assets/imgs/avatar/' +
                    settings.personaje +
                    '.png')
                "
                alt="Encauce"
                class="img-fluid"
              />
              <img
                src="../../assets/imgs/progreso/brillo-amarillo.png"
                alt="Encauce"
                class="img-fluid brillo"
              />

              <div
                class="gadget"
                :class="avance.misiones[0].resultado_evaluacion"
              >
                <img
                  class="w-100 gadget1"
                  :src="
                    require('../../assets/imgs/mision/1/gadgets/' +
                      settings.personaje +
                      '-' +
                      avance.misiones[0].resultado_evaluacion +
                      '.png')
                  "
                  :alt="resultado"
                />
              </div>

              <div class="gadget2">
                <img
                  class="w-100"
                  :src="
                    require('../../assets/imgs/mision/2/gadgets/' +
                      settings.personaje +
                      '-' +
                      resultados[avance.misiones[1].fortaleza].slug +
                      '.png')
                  "
                  :alt="resultado"
                />
              </div>
            </div>

            <div class="menu abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../assets/imgs/mision/bg-menu.png"
                alt="Encauce"
                class="img-fluid w-100 bgmenu"
              />

              <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
                <img
                  src="../../assets/imgs/mision/bg-pregunta.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>
              <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
                <img
                  src="../../assets/imgs/mision/quasar-verde.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="amarillo bold fpXG">¡Hemos terminado!</div>
                <div class="blanco lighter">Gracias por tu ayuda.</div>
              </div>

              <!-- <div
                @click="avanzar"
                class="btnavanzar abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <img
                  src="../../assets/imgs/mision/flecha.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="texto blanco">
                  <span><span>Regresar a </span> <span class="bold">Universos</span></span>
                </div>
              </div>  -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";
import swal from "sweetalert2";
import router from "../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      avance: null,
      settings: {
        personaje: null,
        mision: "resultados descarga",
      },
      resultados: {
        habilidad_0: {
          nombre: "PROCEDIMENTAL",
          gadget: "MARCA PROCEDIMENTAL",
          slug: "procedimental",
          detalle:
            "Te gusta ser ordenado en todos los ámbitos de acción, seguir procedimientos y establecer rutinas y esquemas para conseguir resultados. La observación a los detalles son parte de tu manera de conducirte, por lo que tus estándares de trabajo son de alto rendimiento y eres extremadamente meticuloso, abordando tareas y resolviendo problemas paso a paso. Eres partidario de los valores tradicionales.",
        },
        habilidad_1: {
          nombre: "EMPÁTICO",
          gadget: "MARCA EMPÁTICA",
          slug: "empatico",
          detalle:
            "Ves la vida de manera espiritual y basada en sentimientos. Eres sensible y te conduces por tus emociones e intuiciones. Tiendes a ser muy expresivo y buscas siempre el bienestar, conectando con los demás. Consideras de suma importancia el cómo se sienten los demás. Tienes un sentido humanitario, buscas la armonía en todos los aspectos de tu vida. Tienes una gran habilidad para relacionarte de manera positiva y con empatía, destacas motivando a los demás.",
        },
        habilidad_2: {
          nombre: "ANALÍTICO",
          gadget: "MARCA ANALÍTICA",
          slug: "analitico",
          detalle:
            "Procesas la información de manera analítica, a través de la cual enfocas todo tu pensamiento lógico-matemático para la resolución de problemas, el uso de maquinaria y sus derivados. Tu potencial te impulsa a definir metas y retos que te permiten construir estrategias perfectamente definidas para la consecución de resultados y con ello podrás acceder a posiciones de liderazgo clave, donde la toma de decisiones puntuales y certeras es de suma importancia. Tienes un gusto marcado por las cuestiones técnicas, la mecánica y con lo relacionado a las finanzas.",
        },
        habilidad_3: {
          nombre: "CREATIVO",
          gadget: "MARCA CREATIVA",
          slug: "creativo",
          detalle:
            "Eres muy visual, espacial y no verbal. Tu característica principal es la creatividad, te concentras en imágenes y a partir de ellas recreas conceptos y definiciones, lo que te permite ser sumamente creativo e innovador en todos los procesos que emprendes. Te aburres fácilmente y buscas constantemente la estimulación en nuevos conceptos, nuevas aventuras e información. Muestras un gran interés en todo lo que sucede en tu entorno a nivel social y comunitario. Gozas de un sentido del humor muy especial.",
        },
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      res: -1,
      oraculo: false,
      resultado: false,
      time: 0,
      mision: 1,
      reto: 3,
      estilo_de_aprendizaje: {},
      estilo_de_pensamiento: {},
      perfil_de_competencias: [],
      aprendizaje_usuario: "",
      fortaleza_usuario: "",
      debilidad_usuario: "",
      perfil_de_competencias_usuario: [],
      resultado_nivel_2: null,
      resultado_nivel_1: null,
      camposObj: null,
      campos_aptos: null,
      campos_especificos_usuario: [],
      bases: null,
      base_seleccionada: null,
      base_seleccionada_obj: null,
      frase_nivel_5: null,
      initiated: false,
      perfil_stem: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.init();

    this.revisaSTEM();
  },
  methods: {
    init() {
      if (this.userProfile == null || this.initiated == true) {
        return;
      }

      console.log("iniciando descarga resultados");

      this.initiated = true;

      /////////////////////

      this.estilo_de_aprendizaje = this.$store.state.estilo_de_aprendizaje;
      this.estilo_de_pensamiento = this.$store.state.estilo_de_pensamiento;
      this.perfil_de_competencias = this.$store.state.perfil_de_competencias;
      this.camposObj = this.$store.state.campos_conocimiento;
      this.campos_especificos = this.$store.state.campos_especificos;

      console.log({ camposObj: this.camposObj });

      this.getAvance();
    },
    revisaSTEM() {
      let thes = this;
      let campos_usuario = this.getCamposUsuario();
      console.log("revisa stem");
      console.log({ campos_usuario });

      campos_usuario.forEach((campo) => {
        console.log({ campoid: campo.id });
        if (campo.id == 5 || campo.id == 5 || campo.id == 7) {
          thes.perfil_stem = true;
        }
      });
    },
    async getAvance() {
      let vm = this;
      this.avance = await this.$store.dispatch("getAvance");
      console.log({ avance: this.avance });

      this.avatar = this.avance.avatar;
      if (this.avatar != null) {
        this.settings.personaje =
          this.avatar.slug_personaje + "-" + this.avatar.id_outfit;
      }

      //nivel 1
      this.aprendizaje_usuario = this.avance.misiones[0].resultado_evaluacion;

      //nivel 2
      this.resultado_nivel_2 = this.avance.misiones[1];
      this.fortaleza_usuario = this.resultado_nivel_2.fortaleza;
      this.getDebilidad();
      console.log({ debilidad: this.debilidad_usuario });
      this.perfil_de_competencias_usuario = this.resultado_nivel_2.competencias;

      this.campos_aptos = this.avance.misiones[2].campos_aptos;
      console.log({ campos_aptos: this.campos_aptos });
      this.initCampos();

      this.bases = this.$store.state.bases;

      if (this.avance.misiones[3].base_seleccionada != null) {
        this.base_seleccionada = this.avance.misiones[3].base_seleccionada;
        this.base_seleccionada_obj =
          this.bases["base_" + this.avance.misiones[3].base_seleccionada];
      }
    },
    getDebilidad() {
      switch (this.fortaleza_usuario) {
        case "habilidad_0":
          this.debilidad_usuario = "habilidad_3";
          break;
        case "habilidad_1":
          this.debilidad_usuario = "habilidad_2";
          break;
        case "habilidad_2":
          this.debilidad_usuario = "habilidad_1";
          break;
        case "habilidad_3":
          this.debilidad_usuario = "habilidad_0";
          break;
      }
    },
    avanzar() {
      this.$router.push("/vias");
    },
    retroceder() {
      this.$router.push("/vias");
    },
    async setAvance() {
      let data = {
        index_mision: this.mision - 1,
        write: { mision: this.mision, reto: this.reto + 1, total: 4 },
      };

      await this.$store.dispatch("setAvance", data);
    },

    siguienteMision() {
      this.$router.push("/mision-1-4");
    },
    toggleOraculo() {
      this.oraculo = !this.oraculo;
    },
    objectSize(obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) size++;
      }
      return size;
    },
    generaPDF() {
      this.$store.dispatch("showLoader", true);

      //generar data

      //encontrar perfil de competencias
      // console.log({
      //   perfil_de_competencias_usuario: this.perfil_de_competencias_usuario,
      // });

      let perfil_competencias_pdf = {};
      this.perfil_de_competencias.forEach((perfil) => {
        // console.log({ perfil: perfil });
        // console.log({
        //   usuarilength: this.objectSize(this.perfil_de_competencias_usuario)
        // });
        if (
          perfil.habilidades_necesarias.length ==
          this.objectSize(this.perfil_de_competencias_usuario)
        ) {
          //continuar busqueda
          let concordancia = true;
          for (var i = 0; i < 4; i++) {
            //console.log({ habilidad: this.perfil_de_competencias_usuario[i] });
            if (this.perfil_de_competencias_usuario[i] != null) {
              if (
                !perfil.habilidades_necesarias.includes(
                  this.perfil_de_competencias_usuario[i][0]
                )
              ) {
                concordancia = false;
              }
            }
          }

          if (concordancia === true) {
            perfil_competencias_pdf = perfil;
          }
        }
      });

      //get campos
      let campos_usuario = this.getCamposUsuario();
      console.log({ campos_usuario });

      //get frase nivel 5
      this.frase_nivel_5 = this.getFrase();

      //llamado api

      const https = require("https");

      var qData = {
        estilo_de_aprendizaje:
          this.estilo_de_aprendizaje[this.aprendizaje_usuario],
        fortaleza: this.estilo_de_pensamiento[this.fortaleza_usuario],
        debilidad: this.estilo_de_pensamiento[this.debilidad_usuario],
        perfil_de_competencias: perfil_competencias_pdf,
        nombre_usuario: this.userProfile.nombre,
        campos_especificos: campos_usuario,
        base_seleccionada_obj: this.base_seleccionada_obj,
        frase_nivel_5: this.frase_nivel_5,
      };

      console.log({ getPDF: qData });

      this.$http
        .post(
          "https://reporteriapdfprod.com/api/resultados/pdf-resultado.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res pdf");
            console.log(response);

            //window.open("data:application/pdf," + response.body);

            // let pdfWindow = window.open("");
            // pdfWindow.document.write(
            //   "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            //     response.bodyText +
            //     "'></iframe>"
            // );

            var byteCharacters = response.bodyText;
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);
            //window.open(fileURL, "Encauce - Tus Resultados - " + this.userProfile.nombre);

            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.download =
              "Encauce - Tus Resultados " + ".pdf";
            fileLink.click();
            // let pdfWindow = window.open("", 'Encauce - Tus Resultados');

            // pdfWindow.document.write(
            //   "<iframe width='100%' height='100%' src='" +
            //     fileURL +
            //     "'></iframe>"
            // );
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    initCampos() {
      let thes = this;
      this.campos_aptos.forEach((element) => {
        thes.camposObj["obj" + element.campo].display = true;
        let campo_especifico =
          thes.campos_especificos["obj" + element.campo_especifico];
        if (
          !thes.camposObj[
            "obj" + element.campo
          ].campos_especificos_usuario.includes(campo_especifico)
        ) {
          thes.camposObj["obj" + element.campo].campos_especificos_usuario.push(
            campo_especifico
          );
        }
      });
      console.log({ camposObj: this.camposObj });
    },
    getCamposUsuario() {
      let thes = this;
      let temp = [];
      for (var i = 1; i < 11; i++) {
        if (thes.camposObj["obj" + i].display === true) {
          temp.push(thes.camposObj["obj" + i]);
        }
      }
      return temp;
    },
    getFrase() {
      let frase = null;

      if (this.avance.misiones[4].res1 != null) {
        frase =
          this.bases["base_" + this.base_seleccionada].enunciados[0] +
          " " +
          this.userProfile.nombre +
          " " +
          this.avance.misiones[4].res1.toLowerCase() +
          " al objetivo " +
          this.avance.misiones[4].res2.toLowerCase() +
          " " +
          this.avance.misiones[4].res3.toLowerCase() +
          ", enfocándose en " +
          this.avance.misiones[4].res4.toLowerCase() +
          ".";
      }

      return frase;
    },
  },
};
</script>

<style lang="scss" scoped>
.mision {
  .contentabs {
    .oraculo {
      top: 1%;
      width: 28vw;
      right: 0vw;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      .btnoraculo {
        width: 80%;
        margin-left: 20%;
        position: relative;
      }
      .dialogo {
        position: absolute;
        right: 0%;
        top: 0%;
        width: 120%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
          pointer-events: initial;
        }
        .cerrar {
          position: absolute;
          top: 3%;
          right: 6%;
        }
        .titulo {
          position: absolute;
          width: 50%;
          margin: 0 10% 0 40%;
          top: 12%;
          height: 20%;
          display: flex;
          align-items: center;
          font-size: 1.5vw;
        }
        .texto {
          position: absolute;
          width: 80%;
          margin: 0 10%;
          top: 40%;
          font-size: 1.4vw;
        }
      }
    }
    .tiempo-score {
      position: absolute;
      bottom: 3vw;
      right: 8vw;
      width: 20vw;
    }
    .btnavanzar {
      background: rgb(99, 28, 208);
      background: linear-gradient(
        90deg,
        rgba(99, 28, 208, 1) 35%,
        rgba(40, 112, 250, 1) 100%
      );
      border-radius: 30px;
      color: white;
      bottom: 40%;
      right: 5%;
      width: 20%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: pointer;
      img {
        width: 5vw;
        padding: 0.4vw 0.6vw;
        float: right;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        top: 3%;
        left: 4%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.5vw;
        span {
          width: 100%;
          font-size: 1.1vw;
          text-align: right;
        }
      }
      &:hover {
        background: linear-gradient(
          90deg,
          rgba(40, 112, 250, 1) 0%,
          rgba(99, 28, 208, 1) 100%
        );
        box-shadow: 0 1.2vw 2vw 0px rgba(0, 0, 0, 0.3);
      }
    }
    .menu {
      bottom: 0%;
      left: 0%;
      right: 0%;
      width: 100%;
      position: absolute;
      .bgmenu {
        opacity: 0;
      }
    }
    .pregunta {
      bottom: 14%;
      left: 5%;
      width: 50%;
      position: absolute;
    }
    .quasar {
      bottom: 14.3%;
      left: 2%;
      width: 9%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
    }
    .pregunta_txt {
      bottom: 27%;
      left: 12%;
      width: 40%;
      position: absolute;
      div {
        /*font-size: 1.3vw;*/
      }
    }
    .mensaje {
      position: absolute;
      top: -8vw;
      left: 10%;
      width: 22vw;
      z-index: -1;
      img {
        width: 100%;
      }
      .texto {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 0.3vw 1vw 0.3vw 2vw;
        display: flex;
        justify-content: center;
        align-items: center;
        div,
        span {
          font-size: 1.4vw;
        }
      }
      &.invertido {
        left: -4vw;
        .texto {
          padding: 0.3vw 1vw 0.3vw 2vw;
        }
      }
    }
    .checkbox {
      top: -24%;
      width: 6%;
      position: absolute;
      cursor: pointer;
      .check {
        position: absolute;
        top: 0%;
        left: 10%;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
        }
      }
    }
    .checkbox1 {
      left: 13.5%;
    }
    .checkbox2 {
      left: 35.5%;
      top: -74%;
    }
    .checkbox3 {
      left: 58%;
      top: -74%;
    }
    .checkbox4 {
      left: 81%;
    }

    .personaje {
      bottom: 4%;
      right: 10%;
      width: 22%;
      position: absolute;
      img {
        width: 100%;
      }
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
      .gadget {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        img {
          width: 100%;
        }
      }
      .gadget2 {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        img {
          width: 100%;
        }
      }
    }

    @media (min-width: 993px) {
    }

    .btnretroceder {
      color: white;
      top: 12.5%;
      left: -5%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      z-index: 100;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 45%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 0.9vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}

.mision1_3 {
  background: url(../../assets/imgs/resultados/bg-final.jpg) no-repeat;
  background-size: cover;
  background-position: bottom right;
  .opcion1 {
    top: -110%;
    left: 7%;
    width: 20%;
    position: absolute;
    .atomo {
      position: absolute;
      top: 0%;
      left: -40%;
      width: 150%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion2 {
    top: -160%;
    left: 28%;
    width: 20%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -63%;
      width: 240%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion3 {
    top: -160%;
    left: 53%;
    width: 20%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -65%;
      left: -40%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion4 {
    top: -110%;
    left: 74%;
    width: 20%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -45%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }

  .btn-descarga {
    position: absolute;
    width: 50%;
    top: 25%;
    left: 10%;
    cursor: pointer;
    background: url(../../assets/imgs/registro/dialogo.png) no-repeat;
    background-size: 100% 100%;
    padding: 4vw;
  }
}
</style>